import React, { memo, useContext, useEffect, useState } from "react";

// Utils

import styled from "styled-components";

import IcDeleteActive from "../../../resources/images/icon/icon_component_01_delete_active.svg";
import IcDetail from "../../../resources/images/icon/icon_component_01_detail.svg";

import IcAfter from "../../../resources/images/icon/icon_after.svg";
import IcFolder from "../../../resources/images/icon/icon_folder.svg";
import IcImgBg from "../../../resources/images/icon/icon_image_wth_min.png";
// import IcCheckOff from "../../../resources/images/icon/checkbox/checkbox_default.svg";
import IcCheckOn from "../../../resources/images/icon/checkbox/checkbox_select.svg";
import IcCheckOff from "../../../resources/images/icon/checkbox/test.svg";
import IcTrtmtNew from "../../../resources/images/icon/trtmtData/card/Icon_trtmt_new.svg";

import { AppContext, SocketCommand, socketManager } from "../../../components/AppProvider";
import { IC } from "../../../resources/Assets";
import { openLayerFn } from "../../Layout";
import { socketEtcView } from "./SocketAction/EtcView";

export default memo((props) => {
  const { userinfo, cfg, phonecfg } = useContext(AppContext);
  const { dataList, setDeleteSeqNo, isCheckAll, setIsCheckAll, checkedSeqNo, setCheckedSeqNo } = props;

  const [ aprvDataList, setAprvDataList ] = useState([]);
  const [ existingDataList, setExistingDataList ] = useState([]);
    
  useEffect(() => {
    // 필터링 전 초기화
    setAprvDataList([]);
    setExistingDataList([]);
    // 필터링
    dataList.filter(function (data, index) {
      if (data.newYn === "Y") {
        setAprvDataList((aprvDataList) => [...aprvDataList, data]);
      } else {
        setExistingDataList((existingDataList) => [...existingDataList, data]);
      }
    });
  }, [dataList]);

  const checkName = (checkString, maxLength, cutLengthParam) => {
    let rtnValue = checkString;
    let cutLength = 3;

    if (cutLength) {
      cutLength = cutLengthParam;
    }

    // 병원명이 5글자 이상인경우 3글자+...표시
    if (rtnValue.length >= maxLength) {
      rtnValue = rtnValue.substring(0, cutLength) + "...";
    }

    return rtnValue;
  };

  const settingSeqNo = () => {
    let checkArr = new Array();

    $("input[name=checkSeqNo]:checked").each(function () {
      checkArr.push($(this).attr("id"));
    });

    setCheckedSeqNo(checkArr);

    if (dataList.length == checkArr.length) {
      setIsCheckAll(true);
    } else {
      setIsCheckAll(false);
    }
  };

  // 전체 선택 기능 추가
  const checkedAll = () => {
    if (isCheckAll) {
      $("input:checkbox").prop("checked", false);
      settingSeqNo();
      setIsCheckAll(false);
    } else {
      $("input:checkbox").prop("checked", true);
      settingSeqNo();
      setIsCheckAll(true);
    }
  };

  const unCheckedAll = () => {
    $("input:checkbox").prop("checked", false);
    settingSeqNo();
  };

  useEffect(() => {
    if (dataList.length != checkedSeqNo.length) {
      setIsCheckAll(false);
    }
  }, [checkedSeqNo]);

  return (
    <List>
      {/* <ListHeader onClick={()=>checkedAll()}>
          <ItemCheckedAll
            type={"checkbox"}
            name={"checkTargetAll"}
            checked={isCheckAll}
            readOnly
          />
          <SelectAllText>전체선택</SelectAllText>
      </ListHeader> */}

      {aprvDataList.length > 0 && (
        <div>
          <SelectAllText>새로운 자료</SelectAllText>
          <SelectAllSubText> {"*"} 1주일 이후 진료일별 자료에서 제공됩니다.</SelectAllSubText>
        </div>
      )}

      {aprvDataList.length > 0 &&
        aprvDataList.map((m, i) => (
          <ListItem on="true" key={"dataList" + i}>
            <ListItemInfoLayer on="true">
              <LineOneLayer>
                <div style={{ display: "flex" }}>
                  <label style={{ display: "flex" }} onClick={settingSeqNo}>
                    <div>
                      <ItemChecked
                        id={m.seqNo}
                        type={"checkbox"}
                        name={"checkSeqNo"}
                        onClick={settingSeqNo}
                      />
                    </div>
                    <div style={{ lineHeight: "45px" }}>
                      <ItemDate>{m.dataDt}</ItemDate>
                    </div>
                  </label>
                  <div style={{ marginLeft: "auto", lineHeight: "45px" }}>
                    <ItemHospital onClick={() => socketEtcView("U", m)}>수정</ItemHospital>
                    <ItemMap>
                      <ImgPen src={IC.etc.IC_PEN_GRAY} verticalAlign={"text-top"} />
                    </ItemMap>
                  </div>
                </div>
              </LineOneLayer>
              <LineTwoLayer>
                <div style={{ width: "26px" }}>
                  {m.newYn == "Y" && (
                    <Img src={IcTrtmtNew} verticalAlign={"text-top"} padding={"0px"} alt="" />
                  )}
                </div>
                <div style={{ paddingLeft: "10px" }}>
                  <Img
                    src={m.dataType == "ED" ? IcFolder : IcAfter}
                    verticalAlign={"text-top"}
                    padding={"0px"}
                    alt=""
                  />
                </div>
                <ContentText on="true">{m.dataTitle}</ContentText>

                {m.fileCnt > 0 && (
                  <ImgCnt>
                    <ImgCntI src={IcImgBg} />
                    {m.fileCnt}
                  </ImgCnt>
                )}
              </LineTwoLayer>
            </ListItemInfoLayer>

            <ListButtonLayer on="true">
              <LeftButton
                onClick={() => {
                  setDeleteSeqNo(m.seqNo);
                  openLayerFn($(".confirm-layer"));
                }}
              >
                <Img src={IcDeleteActive} verticalAlign={"text-top"} padding="0px" alt="" />
                <ButtonText on="true">삭제</ButtonText>
              </LeftButton>
              <RightButton
                on="true"
                onClick={() => {
                  socketManager(SocketCommand.FILE_UPLOAD, undefined, {
                    type: "download",
                    userToken: userinfo.userToken.toString(),
                    masterKeys: [
                      { masterKey1: m.seqNo.toString(), masterKey2: "", masterKey3: "" },
                    ],
                    bizType: "ED",
                    bizName: "기타입력자료",
                    bizDtlType: "",
                    viewYN: "Y",
                    saveExtYN: "N",
                    redirectURL: "cnntHspt/1",
                    colorType: "PP",
                    hsptSharYn: "Y",
                    bizSubType: "1",
                  });
                }}
              >
                <Img src={IcDetail} verticalAlign={"text-top"} padding="0px" alt="" />
                <ButtonText on="true">상세보기</ButtonText>
              </RightButton>
            </ListButtonLayer>
          </ListItem>
        ))}

      {existingDataList.length > 0 && (
        <div>
          <SelectAllText>일시별 자료</SelectAllText>
        </div>
      )}

      {existingDataList.length > 0 &&
        existingDataList.map((m, i) => (
          <ListItem on="true" key={"dataList" + i}>
            <ListItemInfoLayer on="true">
              <LineOneLayer>
                <div style={{ display: "flex" }}>
                  <label style={{ display: "flex" }} onClick={settingSeqNo}>
                    <div>
                      <ItemChecked
                        id={m.seqNo}
                        type={"checkbox"}
                        name={"checkSeqNo"}
                        onClick={settingSeqNo}
                      />
                    </div>
                    <div style={{ lineHeight: "45px" }}>
                      <ItemDate>{m.dataDt}</ItemDate>
                    </div>
                  </label>
                  <div style={{ marginLeft: "auto", lineHeight: "45px" }}>
                    <ItemHospital onClick={() => socketEtcView("U", m)}>수정</ItemHospital>
                    <ItemMap>
                      <ImgPen src={IC.etc.IC_PEN_GRAY} verticalAlign={"text-top"} />
                    </ItemMap>
                  </div>
                </div>
              </LineOneLayer>
              <LineTwoLayer>
                <div style={{ width: "26px" }}>
                  {m.newYn == "Y" && (
                    <Img src={IcTrtmtNew} verticalAlign={"text-top"} padding={"0px"} alt="" />
                  )}
                </div>
                <div style={{ paddingLeft: "10px" }}>
                  <Img
                    src={m.dataType == "ED" ? IcFolder : IcAfter}
                    verticalAlign={"text-top"}
                    padding={"0px"}
                    alt=""
                  />
                </div>
                <ContentText on="true">{m.dataTitle}</ContentText>

                {m.fileCnt > 0 && (
                  <ImgCnt>
                    <ImgCntI src={IcImgBg} />
                    {m.fileCnt}
                  </ImgCnt>
                )}
              </LineTwoLayer>
            </ListItemInfoLayer>

            <ListButtonLayer on="true">
              <LeftButton
                onClick={() => {
                  setDeleteSeqNo(m.seqNo);
                  openLayerFn($(".confirm-layer"));
                }}
              >
                <Img src={IcDeleteActive} verticalAlign={"text-top"} padding="0px" alt="" />
                <ButtonText on="true">삭제</ButtonText>
              </LeftButton>
              <RightButton
                on="true"
                onClick={() => {
                  socketManager(SocketCommand.FILE_UPLOAD, undefined, {
                    type: "download",
                    userToken: userinfo.userToken.toString(),
                    masterKeys: [
                      { masterKey1: m.seqNo.toString(), masterKey2: "", masterKey3: "" },
                    ],
                    bizType: "ED",
                    bizName: "기타입력자료",
                    bizDtlType: "",
                    viewYN: "Y",
                    saveExtYN: "N",
                    redirectURL: "cnntHspt/1",
                    colorType: "PP",
                    hsptSharYn: "Y",
                    bizSubType: "1",
                  });
                }}
              >
                <Img src={IcDetail} verticalAlign={"text-top"} padding="0px" alt="" />
                <ButtonText on="true">상세보기</ButtonText>
              </RightButton>
            </ListButtonLayer>
          </ListItem>
        ))}
    </List>
  );
});

/* css */

const List = styled.div`
  // padding:30px 20px;
`;

const ListHeader = styled.div`
  width: 100%;
  height: 24px;
  line-height: 24px;

  vertical-align: middle;
  margin-bottom: 10px;
`;
const ItemCheckedAll = styled.input`
  appearance: none !important;
  background: url(${IcCheckOff});
  background-color: #ffffff00 !important;
  width: 18px;
  height: 18px;
  border: 0px;

  // margin-left: 16px;
  margin-right: 10px;

  vertical-align: middle;

  box-sizing: border-box;

  :checked {
    background-image: url(${IcCheckOn});
    // background-image: url(${IC.check.IcCheckOn});
    background-color: #fff !important;
    background-size: 100% 100%;
    background-position: 50%;
    background-repeat: no-repeat;
  }
`;

const SelectAllText = styled.div`
font-weight: 400;
font-size: 14px;
line-height: 17px;
color: #000000;

display: inline-block;
box-sizing: border-box;
flex-direction: column;
`

const SelectAllSubText = styled.div`
font-weight: 400;
font-size: 0.625rem;
line-height: 16px;
color: #6A62E6;

display: inline-block;
box-sizing: border-box;
flex-direction: column;

padding-left: 8px;
`

const RequestDataLayer = styled.div`
  display: inline-block;
  box-sizing: border-box;
  flex-direction: column;

  float: right;
`;

const RequestIcon = styled.div`
  display: inline-block;
  box-sizing: border-box;
  float: right;
  vertical-align: middle;
`;

const RequestImg = styled.img`
  display: inline-block;
  box-sizing: border-box;
`;

const RequestedDataText = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: #999999;

  display: inline-block;
  box-sizing: border-box;
  float: right;
  vertical-align: middle;
`;

const ListItem = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  // gap: 85px;

  position: relative;
  width: 100%;
  height: 120px;
  margin: 0 0 12px 0; // 위, 오른쪽, 아래, 왼쪽

  background: #ffffff;
  border: 1px solid ${(props) => (props.on === "true" ? "#6A62E6" : "#D9D9D9")};
  border-radius: 8px;
  border-bottom-width: medium;
`;

const ListItemInfoLayer = styled.div`
  width: 100%;
  height: 80px;
  display: inline-block;
  flex-direction: row;
  // border: 1px solid #FF0000;

  // border-bottom:1px solid #6A62E6;
  border-bottom: 1px solid
    ${(props) => (props.on === "true" ? "#6A62E6" : "#D9D9D9")};
`;

const LineOneLayer = styled.div`
  width: 100%;
  height: 42px;
  line-height: 42px;
`;

const ItemChecked = styled.input`
  appearance: none !important;
  border: 1px solid #e0e0e0;
  border-radius: 1.5px;
  background-color: #fff !important;
  width: 18px;
  height: 18px;

  margin-left: 16px;
  margin-right: 10px;

  vertical-align: middle;

  box-sizing: border-box;

  :checked {
    background-image: url(${IcCheckOn});
    background-color: #fff !important;
    background-size: 100% !important;
    background-position: 50%;
    background-repeat: no-repeat;
  }
`;

const ItemDate = styled.div`
  color: #000000;

  display: inline-block;
  text-align: center;
  box-sizing: border-box;
`;

const ItemHospital = styled.div`
  // font-family: 'Pretendard';
  // font-style: normal;
  // font-weight: 400;
  // font-size: 14px;

  max-width: 127px;

  margin-right: 16px;
  color: #d0d0d0;

  font-family: "Pretendard";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  display: inline-block;
  box-sizing: border-box;
  float: right;
`;

const Img = styled.img`
  vertical-align:middle;
  // padding-bottom: 3px;
`;

const ImgPen = styled.img`
  // vertical-align:middle;

  // display: inline-block;
  // box-sizing: border-box;
  // float: right;
  vertical-align: ${(props) =>
    props.verticalAlign ? props.verticalAlign : "middle"};
  padding: ${(props) => (props.padding ? props.padding : "2px 0px")};
  width: 11.37px;
  height: 11.39px;
`;

const ItemMap = styled.div`
  margin-right: 8px;

  display: inline-block;
  box-sizing: border-box;
  float: right;
`;

const LineTwoLayer = styled.div`
  // height: 46px;
  // display: inline-block;
  display: flex;
  box-sizing: border-box;

  height: 22px;
  // line-height: 22px;
  line-height: 20px;
  margin: 0 19px 0 17px;

  vertical-align: middle;
`;

const ContentText = styled.div`
  max-width: 58%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;

  margin-left: 10px;
  margin-right: 10px;

  display: inline-block;
  box-sizing: border-box;
  line-height: 22px;

  color: ${(props) => (props.on === "true" ? "#6A62E6" : "#A2A2A2")};
`;

const ListButtonLayer = styled.div`
  width: 100%;
  height: 38px;
  line-height: 38px;
`;

const LeftButton = styled.div`
  width: 50%;

  display: inline-block;
  text-align: center;

  font-family: "Pretendard";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  color: #6a62e6;
  box-sizing: border-box;
`;

const RightButton = styled.div`
  width: 50%;

  display: inline-block;
  text-align: center;

  font-family: "Pretendard";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  color: #6a62e6;
  box-sizing: border-box;

  // border-left:1px solid #6A62E6;
  border-left: 1px solid
    ${(props) => (props.on === "true" ? "#6A62E6" : "#D9D9D9")};
`;

const ButtonText = styled.div`
  display: inline-block;
  box-sizing: border-box;

  margin-left: 4px;

  font-family: "Pretendard";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;

  color: ${(props) => (props.on === "true" ? "#6A62E6" : "#A2A2A2")};
`;

const ImgInText = styled.p`
  display: inline-block;
  position: absolute;
  left: 8.5rem;
  color: #fff;
`;

const ImgCnt = styled.div`
  // position: absolute;
  display: inline-block;
  height: 20px;
  line-height: 20px;
  padding: 0px 5px;
  font-size: 10px;
  color: #fff;
  border-radius: 4px;
  background: #6a62e6;
`;

const ImgCntI = styled.i`
  display: inline-block;
  vertical-align: middle;
  width: 12px;
  height: 12px;
  background: url(${(props) => props.src}) no-repeat center;
  background-size: contain;
  margin: 0 4px 0px 0;
`;

const CheckLabel = styled.label`
  background: url(${IcCheckOff});
  width: 18px;
  height: 18px;

  margin-left: 16px;
  margin-right: 10px;

  vertical-align: middle;

  display: inline-block;
  box-sizing: border-box;

  &:checked {
    background: url(${IcCheckOn});
  }
`;